// Internationalization configuration skeleton
// This file intentionally does not wire into the app yet.

export const defaultLocale = 'en';
export const supportedLocales = ['en'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export const STORAGE_KEYS = {
  locale: 'locale',
};

// TODO: When integrating Traduki, provide your project/app key and environment mapping
export const TRADUKI = {
  // projectKey: 'your-traduki-project-key',
  // apiBaseUrl: 'https://traduki.prod.atl-paas.net',
};
